<div
  class="auto-registration-top-bar"
  [class.dark-mode]="darkMode"
>
  <img
    *ngIf="showLogo"
    class="logo"
    [src]="logoSrc"
    [alt]="logoAlt"
  />

  <div class="watch-video top-bar-actions" *ngIf="showActions">
    <button type="button" class="watch-video-btn" (click)="onWatchVideo()">
      <span class="watch-video-text">{{ 'WatchVideo' | translate }}</span>
      <span class="watch-video-icon-container">
        <span class="watch-video-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-play"
            viewBox="0 0 16 16"
          >
            <path
              d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"
            />
          </svg>
        </span>
      </span>
    </button>
    <lib-language [color]="languageColor"></lib-language>
  </div>
</div>
